<template>
  <div class="bg-card text-left">
    <h2>{{ $t('pages.killer-questions-templates.main.title', 'Killer Questions Templates') }}</h2>
    <b-alert
      variant="warning"
      :show="!rootFolderExists"
    >
      <font-awesome-icon
        icon="exclamation-triangle"
        class="danger-icon m-auto"
      />
      <router-link :to="{ name: 'killerq-templates-add-folder' }">
        {{ $t('pages.killer-questions-templates.main.must-create-root', 'You must create a root folder first') }}
      </router-link>
    </b-alert>
    <Actions
      class="m-4"
      :root-folder-exists="rootFolderExists"
    />
    <div
      v-show="rootFolderExists"
      class="mx-4 mb-2"
    >
      <h3>{{ $t('pages.killer-questions-templates.main.existing-questions', 'Existing questions structure') }}</h3>
      <div class="row">
        <div class="col-12 col-lg-6">
          <b-form-checkbox
            id="showQuestions-checkbox"
            v-model="isShowQuestions"
            size="sm"
          >
            {{ $t('pages.killer-questions-templates.main.view-questions', 'Show folder\'s questions') }}
          </b-form-checkbox>
          <FoldersTree
            :folders-data="killerFolders"
            :show-questions="isShowQuestions"
            :is-expanded="false"
            :is-folder-select="false"
            :show-questions-count="isShowQuestions"
            :selected-question="selectedQuestion"
            :is-question-select="true"
            @question-select="selectQuestion"
          />
        </div>
        <div class="col-12 col-lg-6">
          <div v-show="selectedQuestion.text != ''">
            <div class="mb-3">
              {{ $t('pages.killer-questions-templates.main.selected-question', 'Selected Question') }}
            </div>
            <div>
              <KillerQuestion
                :question-template="selectedQuestion"
                :is-disabled="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '@/components/jobs/killerQuestionsTemplates/Actions';
import FoldersTree from '@/components/jobs/killerQuestionsTemplates/FoldersTree';
import KillerQuestion from "@/components/jobs/blocks/KillerQuestion";

export default {
  components: {
    Actions,
    FoldersTree,
    KillerQuestion
  },
  data() {
    return {
      killerFolders: null,
      isShowQuestions: false,
      selectedQuestion: {
        text: ""
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$hasRole(['admin']);
    },
    rootFolderExists() {
      return this.killerFolders && this.killerFolders.length > 0;
    }
  },
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      let url = this.isAdmin ? '/killer-questions-templates/all-admin'
          : '/killer-questions-templates/all-user';

      this.axios.get(url)
        .then( response => {
          this.killerFolders = response.data;
        });
    },
    selectQuestion(question) {
      if(question == this.selectedQuestion) {
        this.selectedQuestion = {
          text: ""
        };
      } else {
        this.selectedQuestion = question;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .subtext {
    font-size: 0.9rem;
  }

  .danger-icon {
    font-size: 0.9rem;
  }
</style>